import { render } from "./HistoryInput2.vue?vue&type=template&id=eac013ae"
import script from "./HistoryInput2.vue?vue&type=script&lang=js"
export * from "./HistoryInput2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__